<script>
  import sanitizeClassName from '../../utils/sanitizeClassName';
  
  let {
    className = $bindable(),
    dataTestId = 'base-button',
    onClick = () => {},
    ariaLabel = null,
    itemscope = undefined,
    itemtype = undefined,
    children
  } = $props();

  className = sanitizeClassName(className);
</script>

<button class={className} data-testid={dataTestId} onclick={onClick} aria-label={ariaLabel} {itemscope} {itemtype}>
  {@render children?.()}
</button>
